export default "__VITE_ASSET__CLYJ40Ou__"